import * as React from 'react';
import { useIntl } from 'react-intl';
import { Text, cn, getTime, scrollToElement } from '@siteground/styleguide';
import { parseClientMessage } from '../../../utils/parse-message';
import { ChatContext } from '../../chat-context';
import './client-message.css';

const ClientMessage = ({ message, timestamp, className, messageStatus }) => {
  const domRef = React.useRef(null);
  const { shouldAutoScroll } = React.useContext(ChatContext);
  const intl = useIntl();
  const time = getTime(timestamp);

  const classes = cn('sg-client-message', className);

  const contentClasses = cn(
    'sg-client-message__content',
    messageStatus === 'pending' && 'sg-client-message__content--pending',
    messageStatus === 'unconfirmed' && 'sg-client-message__content--unconfirmed'
  );

  React.useEffect(() => {
    if (shouldAutoScroll) {
      scrollToElement(domRef.current, { behavior: 'auto', block: 'start', inline: 'nearest' });
    }
  }, []);

  return (
    <div ref={domRef} className={classes}>
      <div className={contentClasses}>
        <div className="sg-client-message__text">
          <Text color="dark">{parseClientMessage(message)}</Text>

          <Text align="right" color="typography-disabled" size="small">
            {time}
          </Text>
        </div>

        {messageStatus === 'unconfirmed' && (
          <div className="sg-client-message__error">{intl.formatMessage({ id: 'translate.message.not.send' })}</div>
        )}
      </div>
    </div>
  );
};

export default ClientMessage;
